<div
  *ngIf="isPageLoading"
  class="page-overlay"
  style="
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(255,255,255,0.6);
    z-index: 9999;
    pointer-events: all;
    cursor: not-allowed;
  ">
  <div class="flex flex-column align-items-center justify-content-center h-full w-full" style="height: 100vh;">
    <p-progressSpinner
      styleClass="custom-spinner"
      strokeWidth="4"
      animationDuration=".5s"
      aria-label="Loading"
    ></p-progressSpinner>
    <span class="mt-3">{{ loadingText }}</span>
  </div>
</div>
